export const BOOKING_SEARCH_RESULT = 'booking-search-result';
export const HIRE_SEARCH_RESULT = 'search-result';
export const ITEM_SEARCH_INPUT = 'hire-item-search-input';
